import { render, staticRenderFns } from "./CodeBloc.vue?vue&type=template&id=0231b954&scoped=true"
import script from "./CodeBloc.vue?vue&type=script&lang=js"
export * from "./CodeBloc.vue?vue&type=script&lang=js"
import style0 from "./CodeBloc.vue?vue&type=style&index=0&id=0231b954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0231b954",
  null
  
)

export default component.exports